/**
 * 見積り乖離表示の更新に関するフック
 */
import {
  CellEditingStoppedEvent,
  CellValueChangedEvent,
  IRowNode,
} from 'ag-grid-community'
import { ProductBacklogRow, isProductBacklogItemRow } from '../productBacklog'
import {
  FIELD_WBSITEM_ESTIMATED_WORKLOAD_DELIVERABLE,
  FIELD_WBSITEM_ESTIMATED_WORKLOAD_DELIVERABLE_PER_SPRINT,
  FIELD_WBSITEM_STATUS,
} from '../gridOptions/columnDefs'

// 乖離判定に影響する列（見積り列 + ステータス列）
const VARIANCE_AFFECTING_FIELDS = new Set([
  FIELD_WBSITEM_ESTIMATED_WORKLOAD_DELIVERABLE,
  FIELD_WBSITEM_ESTIMATED_WORKLOAD_DELIVERABLE_PER_SPRINT,
  FIELD_WBSITEM_STATUS,
])

// フォーカス再設定が必要な見積り列
const ESTIMATE_FIELDS = new Set([
  FIELD_WBSITEM_ESTIMATED_WORKLOAD_DELIVERABLE_PER_SPRINT,
  FIELD_WBSITEM_ESTIMATED_WORKLOAD_DELIVERABLE,
])

/**
 * 同一成果物の全行を再描画して乖離cellStyleを再評価する
 */
const redrawVarianceRows = (
  api: CellValueChangedEvent<ProductBacklogRow>['api'],
  data: ProductBacklogRow | undefined
) => {
  if (!data || !isProductBacklogItemRow(data) || !api) return

  const rowNodesToRedraw: IRowNode<ProductBacklogRow>[] = []
  api.forEachNode(node => {
    if (
      node.data &&
      isProductBacklogItemRow(node.data) &&
      node.data.originalUuid === data.originalUuid
    ) {
      rowNodesToRedraw.push(node)
    }
  })
  if (rowNodesToRedraw.length > 0) {
    api.redrawRows({ rowNodes: rowNodesToRedraw })
  }
}

/**
 * セル値変更時に同一成果物の全行のcellStyleを再評価するハンドラ
 * 乖離判定に影響する列（見積り列・ステータス列）の変更時のみ再描画する
 */
export const handleEstimateVarianceChanged = (
  e: CellValueChangedEvent<ProductBacklogRow>
) => {
  const colId = e.column.getColId()
  if (!VARIANCE_AFFECTING_FIELDS.has(colId)) return
  redrawVarianceRows(e.api, e.data)
}

/**
 * セル編集終了時（キャンセル含む）に乖離ハイライトを再評価するハンドラ
 * フォーカス管理も兼ねる（redrawRowsでフォーカスが外れるため再設定が必要）
 */
export const handleEstimateVarianceEditingStopped = (
  e: CellEditingStoppedEvent<ProductBacklogRow>
) => {
  const field = e.colDef.field || ''
  if (!VARIANCE_AFFECTING_FIELDS.has(field)) return
  redrawVarianceRows(e.api, e.data)

  // 見積り列のセル編集後、フォーカスを再設定する
  // 同一成果物の複数行で共有配列を更新するとag-gridのフォーカス管理が乱れるため
  if (ESTIMATE_FIELDS.has(field)) {
    const focusedCell = e.api.getFocusedCell()
    if (focusedCell) {
      setTimeout(() => {
        e.api.setFocusedCell(focusedCell.rowIndex, focusedCell.column)
      }, 0)
    }
  }
}
